"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.url-search-params.js");

var _default = {
  "postAnonymousAccessToken": {
    method: 'post',
    path: process.env.REACT_APP_APIGEE_ANONYMOUS_ACCESS_TOKEN_PATH || '/v1/security/oauth/token',
    host: process.env.REACT_APP_APIGEE_HOST_ANONYMOUS_ACCESS_TOKEN || 'https://internal.dev.api.svb.com',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  "getCatalogItems": {
    method: 'get',
    path: process.env.REACT_APP_APIGEE_CATALOG_PATH || '/v1/content/api-catalog-items',
    host: process.env.REACT_APP_APIGEE_CATALOG_HOST || 'https://internal.qa.api.svb.com',
    headers: {
      'Content-Type': 'application/json'
    },
    allowedExtraHeaders: ['Authorization', 'x-svb-correlation-id']
  },
  "getFaqsItems": {
    method: 'post',
    path: process.env.REACT_APP_APIGEE_FAQS_PATH || '/v1/content/faqs/search',
    host: process.env.REACT_APP_APIGEE_FAQS_HOST || 'https://internal.qa.api.svb.com',
    headers: {
      'Content-Type': 'application/json'
    },
    allowedExtraHeaders: ['Authorization']
  },
  "postAccessToken": {
    host: process.env.REACT_APP_TOKEN_HOST || 'https://internal.uat.api.svb.com',
    method: 'post',
    path: process.env.REACT_APP_TOKEN_PATH || '/v1/security/oauth/token',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: (() => {
      const body = new URLSearchParams();
      body.append('grant_type', 'client_credentials');
      return body;
    })(),
    allowedExtraHeaders: ['Authorization']
  },
  "postLogging": {
    host: process.env.REACT_APP_LOGGING_HOST || 'https://logging-example.com',
    method: 'post',
    path: process.env.REACT_APP_LOGGING_PATH || '/log',
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 1000
  },
  "getTest": {
    host: process.env.REACT_APP_TESTING_HOST || 'https://example.com',
    path: process.env.REACT_APP_TESTING_PATH || '/example'
  }
};
exports.default = _default;